import axios from '../axiosInstance.js';

export const getAllSettings = () => axios.get('/settings');